import axios from 'axios';
// import forge from 'node-forge';
import { store } from '../redux/store';
import { reduxUpdateError } from '../redux/reducers/error';
import Cookies from 'universal-cookie';

const normalizeOrigin = (value: string): string =>
   value.replace(/\/+$/, '');

// Runtime contracts:
// REACT_APP_API_ORIGIN
// REACT_APP_BASE_API_URL
// REACT_APP_CONSOLE_ORIGIN

export const webURL = normalizeOrigin(
   process.env.REACT_APP_API_ORIGIN || 'https://api.dragify.ai'
);

export const consoleURL = normalizeOrigin(
   process.env.REACT_APP_CONSOLE_ORIGIN || 'https://console.dragify.ai'
);

export const baseURL = normalizeOrigin(
   process.env.REACT_APP_BASE_API_URL || 'https://api.dragify.ai/proxy/api'
);

export const baseURLExecute = () => {
   const cookies = new Cookies();
   const token = cookies.get('token');

   axios.defaults.baseURL = baseURL;
   axios.defaults.headers.common = {
      'x-auth-token': token,
   };
};

export const interceptorExecute = () => {
   axios.interceptors.request.use(
      (config) => config,
      (error) => Promise.reject(error)
   );

   axios.interceptors.response.use(
      (response) => response,
      (error) => {
         const url = String(error?.config?.url || '');
         const silentIntegrationNoise =
            url.includes('googleToken') ||
            url.includes('microsoftToken') ||
            url.includes('jiraToken') ||
            url.includes('spreadsheet/sheets') ||
            url.includes('user_spreadsheets');

         if (!silentIntegrationNoise) {
            console.log('error', error);
         }

         if (
            !silentIntegrationNoise &&
            window.location.pathname === '/workflow'
         ) {
            const message =
               error?.response?.data ||
               error?.message ||
               error?.request ||
               'An error occurred';

            store.dispatch(
               reduxUpdateError(JSON.stringify(message, null, 1))
            );
         }

         return Promise.reject(error);
      }
   );
};

// Cancel all requests
let cancelTokenSource = axios.CancelToken.source();

const resetCancelTokenSource = () => {
   cancelTokenSource = axios.CancelToken.source();
};

export const applyCancelTokenInterceptor = () => {
   axios.interceptors.request.use((config) => {
      config.cancelToken = cancelTokenSource.token;
      return config;
   });
};

export const cancelAllRequests = () => {
   cancelTokenSource.cancel('All requests were cancelled');
   resetCancelTokenSource();
};